<template>
  <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.6238 24.3333H17.0681V15.9154H19.4753L19.7282 13.1H17.0681V11.4969C17.0681 10.8318 17.2092 10.5686 17.863 10.5686H19.7273V7.66666H17.3386C14.7758 7.66666 13.6238 8.76985 13.6238 10.8736V13.1209H11.8335V15.9648H13.6238V24.3333Z"/>
  </svg>
</template>